import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {Cross} from 'shared/ui/icons'
import {Modal} from 'shared/ui/modal'
import {agreementPoints, firstText, footerText} from './config'
import {setIsOpenDatingSafetyPolicy, useDatingSafetyPolicyIsOpen} from './model'
import styles from './styles.module.scss'

export const DatingSafetyPolicyModal: FC = () => {
  const dispatch = useDispatch()
  const isOpen = useDatingSafetyPolicyIsOpen()

  const onClose = () => dispatch(setIsOpenDatingSafetyPolicy(false))

  if (!isOpen) return <></>

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          Dating safety policy
          <div className={styles.closeIcon} onClick={onClose}><Cross /></div>
        </div>
        <div className={styles.content}>
          <div className={styles.firstText}>
            {firstText}
          </div>
          {agreementPoints.map((item, index) => <div key={index} className={styles.agreementPoint}>
            <div className={styles.agreementPointHeader}>
              <div className={styles.index}>{index + 1}.</div>
              {item.header}
            </div>
            <div className={styles.agreementPointText}>{item.text}</div>
          </div>)}
          <div className={styles.footerText}>
            Happy Dating!<br />
            {footerText}
          </div>
        </div>
      </div>
    </Modal>
  )
}
